import { render, staticRenderFns } from "./xclx.vue?vue&type=template&id=7e9680d0&scoped=true&"
import script from "./xclx.vue?vue&type=script&lang=js&"
export * from "./xclx.vue?vue&type=script&lang=js&"
import style0 from "./xclx.vue?vue&type=style&index=0&id=7e9680d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9680d0",
  null
  
)

export default component.exports